import { defineMessages } from 'react-intl'

export default defineMessages({
  help: {
    id: 'containers.SupplierSignUp.help',
    defaultMessage: 'Help',
  },
})
